module.exports = __webpack_public_path__ + "static/media/react-project1-b.33a31544.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/react-project1-b.png
// module id = 35
// module chunks = 0